export const locales = {
  en: require('./en')
};
const messages = {
  backForward: '返回',
  application: '开发指引',
  baseInfo: '基本信息',
  basicInformation: "基础信息",
  voucherAndBasicInformation: "凭证与基础信息",
  membersManage: '成员管理',
  applicationCapability: "应用能力",
  addAppCapabilities: "添加应用功能",
  applicationWe: "We码",
  applicationLight: "轻应用",
  applicationRobot: "机器人",
  developmentConfiguration: "开发配置",
  permissionManagement: "权限管理",
  eventsAndCallbacks: "事件与回调",
  securitySettings: "安全设置",
  applicationRelease: "应用发布",
  versionManagementAndRelease: "版本管理与发布",
  operationAndMonitoring: "运营与监控",
  logRetrieval: "日志检索",
  editionManage: '版本管理',
  powerManage: '权限申请',
  apiManage: '接口管理',
  securitySet: '安全设置',
  versionManageRelease: '版本管理与发布'
};

export default {locales, ...messages};
